import * as types from './weaveActionTypes';

export const getWeaveRequestAction = (payload) => ({
  type: types.GET_WEAVE_REQUEST,
  payload,
});

export const getWeaveDataAction = (payload) => ({
  type: types.GET_WEAVE_DATA,
  payload,
});

export const getWeaveErrorAction = (payload) => ({
  type: types.GET_WEAVE_ERROR,
  payload,
});

export const createWeaveRequestAction = (payload) => ({
  type: types.CREATE_WEAVE_REQUEST,
  payload,
});

export const createWeaveDataAction = (payload) => ({
  type: types.CREATE_WEAVE_DATA,
  payload,
});

export const createWeaveErrorAction = (payload) => ({
  type: types.CREATE_WEAVE_ERROR,
  payload,
});

export const updateWeaveRequestAction = (payload) => ({
  type: types.UPDATE_WEAVE_REQUEST,
  payload,
});

export const updateWeaveDataAction = (payload) => ({
  type: types.UPDATE_WEAVE_DATA,
  payload,
});

export const updateWeaveErrorAction = (payload) => ({
  type: types.UPDATE_WEAVE_ERROR,
  payload,
});

export const deleteWeaveRequestAction = (payload) => ({
  type: types.DELETE_WEAVE_REQUEST,
  payload,
});

export const deleteWeaveDataAction = (payload) => ({
  type: types.DELETE_WEAVE_DATA,
  payload,
});

export const deleteWeaveErrorAction = (payload) => ({
  type: types.DELETE_WEAVE_ERROR,
  payload,
});
